"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const react_1 = __importStar(require("react"));
const react_final_form_1 = require("react-final-form");
const FormContexts_1 = require("../Contexts/FormContexts");
const mapHelpers_1 = require("../utils/mapHelpers");
const ConditionalChildren_1 = require("./ConditionalChildren");
/**
 * This is a small component used to short circuit form controls which do not have a conditional map.
 * The reason we can't just put this in the actual Conditional component is that the conditional evaluation
 * requires looking up the current form state which is expensive, and that hook(like all hooks) can't be made conditional.
 * @param conditionalMap The mapping used to determine the visibility of the current form object
 */
const ComputedRenderer = (props) => {
    const { functionDefinitions } = FormContexts_1.useControlProvider();
    const { controlPath, controlDefinition, children } = props;
    const formState = react_final_form_1.useFormState({ subscription: { values: true } });
    const thisField = react_final_form_1.useField(controlPath);
    const [computedMap] = react_1.useState(controlDefinition.computedMap);
    const formDataMapping = FormContexts_1.useFormDataMappingSources(); // get any supplemental state to pass to data mapper
    const computedRefs = react_1.useMemo(() => (computedMap ? ConditionalChildren_1.getRefs(computedMap, ['FORM', 'FORMVALUE']) : {}), [computedMap]);
    const [firstComputedMap, setFirstComputedMap] = react_1.useState(false);
    const [previousState, setPreviousState] = react_1.useState({});
    const [previousValue, setPreviousValue] = react_1.useState({});
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const calculatedCallback = react_1.useCallback(lodash_1.default.debounce((computedMap, acc, functionDefinitions, formState, controlPath, firstComputedMap, previousState, previousValue, computedRefs, thisField) => {
        if (computedMap) {
            // now we need to build a set of data sources for our datamap
            //only check if the field has been interacted with, plus allow override for modal validation
            const allValues = formState.values;
            const value = lodash_1.default.get(allValues, controlPath);
            const parts = (controlPath || '').split('.');
            const t = parts.map((part, idx) => {
                let target = allValues;
                let name = '';
                for (let i = 0; i < idx; i++) {
                    target = lodash_1.default.get(target, parts[i]);
                    name += parts[i].replace(/\[\d+\]/, '') + '.';
                }
                target = target ? lodash_1.default.get(target, part) : undefined;
                name += part.replace(/\[\d+\]/, '');
                return { [name]: target };
            });
            let formValue = { value };
            for (let i = 0; i < t.length; i++) {
                formValue = Object.assign(Object.assign({}, formValue), t[i]);
            }
            // only
            const accessors = Object.assign(Object.assign({}, acc), { FORM: () => {
                    return allValues;
                }, FORMVALUE: () => formValue });
            if (computedMap &&
                (!firstComputedMap ||
                    (computedRefs &&
                        (ConditionalChildren_1.anyValuesChanged(computedRefs['FORMVALUE'], previousValue, formValue) ||
                            ConditionalChildren_1.anyValuesChanged(computedRefs['FORM'], previousState, allValues))))) {
                mapHelpers_1.fieldComputedMapEvaluator(accessors, functionDefinitions, computedMap, true).then((val) => {
                    if (!lodash_1.default.isEqual(val, value)) {
                        //allValues[controlPath] = val;
                        thisField.input.onChange(val);
                    }
                });
            }
            if (!lodash_1.default.isEqual(allValues, previousState)) {
                setPreviousState(lodash_1.default.cloneDeep(allValues));
            }
            if (!lodash_1.default.isEqual(formValue, previousValue)) {
                setPreviousValue(lodash_1.default.cloneDeep(formValue));
            }
            if (!firstComputedMap) {
                setFirstComputedMap(true);
            }
        }
    }, 300), []);
    // we're going to create a validation function that returns errors and warnings
    react_1.useEffect(() => {
        calculatedCallback(computedMap, formDataMapping.accessors, functionDefinitions, formState, controlPath, firstComputedMap, previousState, previousValue, computedRefs, thisField);
    }, [
        computedMap,
        formDataMapping.accessors,
        functionDefinitions,
        formState,
        controlPath,
        firstComputedMap,
        previousState,
        previousValue,
        computedRefs,
        thisField,
        calculatedCallback,
    ]);
    return react_1.default.createElement(react_1.default.Fragment, null, children);
};
exports.default = ComputedRenderer;
